// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"eb5d31dc","453":"259227b0","721":"78ad80e3","802":"d01bc768"}[chunkId] + ".chunk.js";
};